import { useWholesaleCartQuery } from "@shared/data/queries/WholesaleCartQuery/WholesaleCart.query";

const useCartUnitCount = (): number => {
  const { data } = useWholesaleCartQuery();

  if (data?.currentOffice?.wholesaleCart) {
    return data.currentOffice.wholesaleCart.lineItems.reduce(
      (sum, value) => sum + value.quantity,
      0
    );
  }

  return 0;
};

export { useCartUnitCount };
